import { uniq } from 'lodash';

export default function areRegionsMultiDistrict(regions) {
  // We only show the approver notes button to users with whose regions are all
  // in a single district.  This is so we don't have to decide which district
  // a note should be read/written from.
  return uniq(regions.map(r => r.districtId)).length > 1;
}
